<template>
  <div :class="['axiome-logique-container', 'axiome-logique-complement-of']">
    <!-- Affichage Operand -->
    <span :class="['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': level0 }]">not</span>
    <span v-if="blankNodes || complementOfLiterals" class="brace-container-left"></span>

    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="complementOfLiterals" :leftMargin="false" />
      <AttributeBlankNode :blankNodes="blankNodes" :leftMargin="false" :braceDisplay="true"
        :showLanguageBadge="showLanguageBadge"
        :showFirstOperand="complementOfLiterals !== undefined && complementOfLiterals.length > 0" />
    </div>

    <span v-if="blankNodes || complementOfLiterals" class="brace-container-right"></span>
  </div>
</template>

<script>
export default {
  name: "LogicalAxiomeComplementOf",
  computed: {
    complementOfLiterals() {
      let result = [];
      this.complementOf.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    },
    blankNodes() {
      let blankNodes = [];
      this.complementOf.forEach(element => {
        blankNodes.push(...element.blankNodes);
      });
      return blankNodes;
    }
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    complementOf: {
      type: Array,
      default: () => []
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    },
    treeDisplayForLogicalAxiom: {
      type: Boolean,
      default: false
    }
  }
}
</script>
